import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {AuthenticatedResult, OidcSecurityService} from 'angular-auth-oidc-client';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthorizationGuard  {

    constructor(private oidcSecurityService: OidcSecurityService,
                private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.oidcSecurityService.isAuthenticated$
            .pipe(
                map((authenticatedResult: AuthenticatedResult) => authenticatedResult.isAuthenticated)
            );
    }

}
